<script setup lang="ts">
import UploadFieldMultiple from "@/components/ui/inputs/uploadField/UploadFieldMultiple.vue";
import UploadFieldSingle from "@/components/ui/inputs/uploadField/UploadFieldSingle.vue";
import type { TUploadFieldSharedProps } from "@/composables/ui/inputs/useUploadFieldBase";

const props = withDefaults(defineProps<TUploadFieldSharedProps>(), {
  multiple: false,
  maxFiles: null,
  enableImageEditor: false,
});

const emit = defineEmits<{
  editing: [boolean];
}>();
</script>

<template>
  <upload-field-multiple
    v-if="props.multiple"
    v-bind="props"
  />
  <upload-field-single
    v-else
    v-bind="props"
    @editing="emit('editing', $event)"
  />
</template>
